import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import StableMuiDialog from '../../../../common/StableMuiDialog.js';
import {
  CANCEL_BUTTON_SX,
  DIALOG_PAPER_SX,
  PRIMARY_BUTTON_SX,
  colors,
} from '../../Offers/TownPortalFlow/TownPortalOffersDialog.js';

export default function StipDownloadDialog({ open, onClose, onConfirm }) {
  const [countersignedOnly, setCountersignedOnly] = useState(false);

  useEffect(() => {
    if (open) setCountersignedOnly(false);
  }, [open]);

  return (
    <StableMuiDialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{ sx: { ...DIALOG_PAPER_SX, maxWidth: 420 } }}
    >
      <Box sx={{ p: 3 }}>
        <Typography component="h2" sx={{ fontSize: 17, fontWeight: 500, color: colors.textPrimary, m: '0 0 16px' }}>
          Download stipulations
        </Typography>
        <FormControlLabel
          sx={{ display: 'flex', mx: 0, alignItems: 'flex-start', '& .MuiFormControlLabel-label': { fontSize: 13, color: colors.textPrimary, pt: '2px' } }}
          control={
            <Checkbox
              size="small"
              checked={countersignedOnly}
              onChange={(e) => setCountersignedOnly(e.target.checked)}
              sx={{ py: 0 }}
            />
          }
          label="Only download countersigned copies?"
        />
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1, pt: 2.5 }}>
          <Button onClick={onClose} sx={CANCEL_BUTTON_SX}>Cancel</Button>
          <Button
            onClick={() => onConfirm(countersignedOnly)}
            variant="contained"
            disableElevation
            sx={PRIMARY_BUTTON_SX}
          >
            Download
          </Button>
        </Box>
      </Box>
    </StableMuiDialog>
  );
}
